<template>
  <div class="top-up-type summary-list">
    <slot name="txtWithoutAuto">
      <p>Du hast keine Aufladung ausgewählt</p>
    </slot>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import { stepName as topUpStep } from './EnterTopUpAndPayment.vue'

export default {
  name: 'ShowWithoutAuto',
  props: {
    topUpInfo: {
      type: Object
    }
  },
  methods: {
    goToTopUpStep: function() {
      this.goToStep(topUpStep)
    },
    ...mapMutations('activation', ['goToStep'])
  }
}
</script>
